var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "icon-play",
      class: {
        "icon-play--loading": _vm.loading,
        "icon-play--invert": _vm.invert,
        "icon-play--immediate": _vm.immediate,
        animate: _vm.animate
      },
      on: { click: _vm.clickPlay }
    },
    [
      _vm.hasTitle
        ? _c("div", { staticClass: "icon-play__title" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("button_5_1")) + "\n    "),
            _c("br"),
            _vm._v("\n    " + _vm._s(_vm.$t("button_5_2")) + "\n  ")
          ])
        : _vm._e(),
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60"
          }
        },
        [
          _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
            _c("path", {
              staticClass: "icon-play__shape",
              attrs: {
                stroke: "#FFF",
                "stroke-width": "5.669",
                d:
                  "M30 3c14.911 0 27 12.089 27 27S44.911 57 30 57 3 44.911 3 30 15.089 3 30 3s27 12.089 27 27",
                "stroke-dasharray": "212.10 212.10",
                "stroke-dashoffset": "212.10"
              }
            }),
            _c("path", {
              staticClass: "icon-play__path",
              attrs: {
                fill: "#FFF",
                d: "M23 18l20 12-20 12z",
                "stroke-dasharray": "70.65 70.65",
                "stroke-dashoffset": "70.65"
              }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2590690", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2590690","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icons/icon-play-view.vue
// module id = 476
// module chunks = 34